import axios from "axios";
const SOCKET_PORT = process.env.REACT_APP_SOCKET_PORT;

export const getChatListAdmin = (chatData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CHAT_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // console.log("chatData in action:", chatData);
      // console.log("Config in action:", config);
      
      const { data } = await axios.post(
        `${SOCKET_PORT}/api/v1/chat/help-support-group-list`,
        chatData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CHAT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CHAT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      console.error("Full error in getChatListAdmin:", error);
      dispatch({
        type: "GET_CHAT_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getChatListAdminById = (chatData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CHAT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      
      const { data } = await axios.post(
        `${SOCKET_PORT}/api/v1/chat/help-support-list`,
        chatData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CHAT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CHAT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CHAT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getChatListPaymentExec = (chatData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CHAT_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${SOCKET_PORT}/api/v1/chat/payment-executive-group-list`,
        chatData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CHAT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CHAT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CHAT_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getChatPaymentExecById = (chatData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_CHAT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${SOCKET_PORT}/api/v1/chat/payment-executive-list`,
        chatData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_CHAT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_CHAT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_CHAT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
